export default __webpack_public_path__ + "static/media/97bd13_dd987ae869a3492f8a8e2c53eac52779mv2.aafab566.jpg";